/**
 * Parses a station string in the format "integer+decimal" and converts it to a number.
 * @param input - The station string to parse.
 * @returns The numerical representation of the station.
 */
export function parseStationString(input: string): number {
    if (input) {
        const [firstPart, lastPart] = input.split('+').map(part => part.trim());
        const firstPartValue: number = parseInt(firstPart, 10) || 0;
        const lastPartValue: number = parseFloat(lastPart) || 0;
        return (firstPartValue * 100) + Math.round(lastPartValue * 10) / 10;
    }
    return 0;
}

/**
 * Formats a numerical station value into a string with the format "quotient+remainder.decimal".
 * @param input - The numerical station value to format.
 * @returns The formatted station string.
 */
export function formatStationString(input: string): string {
    if (!isNaN(parseFloat(input)) && isFinite(parseFloat(input))) {
        const [integerPart, decimalPart] = input.split('.');
        const quotient: number = Math.floor(parseInt(integerPart) / 100);
        const remainder: number = parseInt(integerPart) % 100;
        const twoDigits = (remainder >= 0 && remainder < 10) ? ('0' + remainder.toString()) : remainder.toString();
        return decimalPart ? `${quotient}+${twoDigits}.${decimalPart}` : `${quotient}+${twoDigits}.0`;
    }
    return '';
}